
const getNiceYAxisMax = (maxValue: number): number => {
  if (maxValue === 0) return 100; // Ensure a minimum scale

  const digits = Math.floor(Math.log10(maxValue)); // Find number of digits
  const base = Math.pow(10, digits); // Round to the nearest power of 10

  return Math.ceil(maxValue / base) * base; // Clean rounding
};

export default getNiceYAxisMax;
